"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contViewLoadCreator = void 0;
var consts_1 = require("../consts");
var contViewLoadCreator = function (event) {
    var eventData = {
        action: 'cont-view',
        event: 'cont-view-load',
        eventInfo: 'cont-view-load',
        cont: {
            contAccess: event.eventData.cont.contAccess || consts_1.NOT_AVAILABLE,
            contCat: event.eventData.cont.contCat || consts_1.NOT_AVAILABLE,
            contID: event.eventData.cont.contID || consts_1.NOT_AVAILABLE,
            contIndustry: event.eventData.cont.contIndustry || consts_1.NOT_AVAILABLE,
            contLang: event.eventData.cont.contLang || consts_1.NOT_AVAILABLE,
            contName: event.eventData.cont.contName || consts_1.NOT_AVAILABLE,
            contSource: event.eventData.cont.contSource || consts_1.NOT_AVAILABLE,
            contTags: event.eventData.cont.contTags || consts_1.NOT_AVAILABLE,
            contTopic: event.eventData.cont.contTopic || consts_1.NOT_AVAILABLE,
        },
    };
    return eventData;
};
exports.contViewLoadCreator = contViewLoadCreator;
